/**
 * Width budget per column of the takeover board. Every column flexes; these are the caps, except for
 * Details and Aktion, which are floors so the description and the action button keep their room.
 */
export const TakeoverColumnWidth = {
  date: 160,
  time: 110,
  location: 120,
  service: 120,
  details: 200,
  from: 90,
  takenOverBy: 150,
  action: 240,
};
